import React, { useEffect } from "react";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const { dashboard_list, d_loading } = useSelector((state) => state.dashboard);

  return (
    <div className="main-home-container">
      {d_loading ? (
        <Loader />
      ) : (
        <div>
          <div className="table-container">
            <table className="scrollable-table">
              <tr className="table-header">
                <th>UUID</th>
                <th>Type</th>
                <th>Temperature</th>
                <th>Cone Out</th>
                <th>Gas Flow Rate</th>
                <th>Date Time</th>
              </tr>

              {dashboard_list.map((v, i) => (
                <tr key={i}>
                  <td>{v.id}</td>
                  <td>{v.type}</td>
                  <td>{v.temperature}</td>
                  <td>{v.countout}</td>
                  <td>{v.flowrate}</td>
                  <td>{v.datetime}</td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
